import './Hero.css';
import { Link } from 'react-router-dom';
import WaitlistButton from '../common/components/waitlist/WaitlistButton';

function Hero() {
  return (
    <section className='home-hero'>
      <div>
        <p className='hero-title white'>
          Sera helps you attain
        </p>
        <p className='hero-title accent-light second'>
          financial wellness
        </p>

        <p className='hero-subtitle white'>
        {/*Build your credit and eliminate your debt faster and at lower interest than any other option.*/}
          As a <u>first step</u> - get out of debt <b>faster</b>, while <b>building credit</b> and <b>controlling your budget</b>.
        </p>
        <div className='buttons-container'>
          <WaitlistButton showBg={false} />
          <div className='how-it-works'>
            <Link to='/how-it-works'><button className='main no-bg transparent'>See how it works</button></Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;